import { ApiBase } from './ApiBase';
class PlatformApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getFeatureFlags = () => {
            return this.get('/platform/features.json');
        };
        this.createLoginSession = (requestBody) => {
            return this.post('/platform/creators/users/login_session', requestBody);
        };
    }
}
export const PlatformApiClient = new PlatformApiClientModel('/');
